import { Box, Button, Center, Flex, Icon, Image, Text } from "@chakra-ui/react";
import { useIsMobileView } from "hooks/usePageSize";
import topBannerPc from "assets/top-banner-bc.png";
import topBannerMobile from "assets/top-banner-mobile.png";
import CustomModal from "components/CustomModal";
import { useState } from "react";
import whyBanner from "assets/why-banner.png";
import whyAvatar from "assets/why-avatar.png";
import bnxBanner from "assets/bnx-banner.png";
import bnxAvatar from "assets/bnx-avatar.png";
import { useNavigate } from "react-router-dom";
import extraCardLogo from "assets/extra-card-logo.png";
import goIcon from "assets/go.png";
import homepageSpinIcon from "assets/homepage-spin.png";
import { useChainId, useReadContract } from "wagmi";
import { getContract } from "config/contracts";
import fomomeContractAbi from "abis/abi-fomome.json";
import { formatAmount, numberWithCommas } from "utils/numbers";
import BigNumber from "bignumber.js";
import playbookContractAbi from "abis/abi-playbook.json";
import { socialMediaLinks } from "config/common";
import { useTokenPrices } from "utils/price";
import { bsc, bscTestnet } from "viem/chains";
import babydogeBanner from "assets/babydoge-banner.png";
import babydogeIcon from "assets/babydoge.png";
import { getMemeTokenInfo } from "config/tokens";

const TOKENS_CARD_INFO = {
  [bsc.id]: [
    {
      topImage: babydogeBanner,
      avatar: babydogeIcon,
      name: "Baby Doge",
      symbol: "BABYDOGE",
      desc: "Baby doge is meme coin that gained attention following a tweet by Elon Mask",
      isComing: false,
    },
    // {
    //   topImage: whyBanner,
    //   avatar: whyAvatar,
    //   name: "EXO",
    //   symbol: "EXO",
    //   desc: "FR It is a Bipolar Elephant, has two souls, MAD after goofing up every 100x from 2019-2024, ...",
    //   isComing: false,
    // },
    {
      topImage: whyBanner,
      avatar: whyAvatar,
      name: "WHY",
      symbol: "WHY",
      desc: "FR It is a Bipolar Elephant, has two souls, MAD after goofing up every 100x from 2019-2024, ...",
      isComing: true,
    },
  ],
  [bscTestnet.id]: [
    {
      topImage: babydogeBanner,
      avatar: babydogeIcon,
      name: "Baby Doge",
      symbol: "BABYDOGE",
      desc: "Baby doge is meme coin that gained attention following a tweet by Elon Mask",
      isComing: false,
    },
    {
      topImage: whyBanner,
      avatar: whyAvatar,
      name: "TF Boy",
      symbol: "TFB",
      desc: "FR It is a Bipolar Elephant, has two souls, MAD after goofing up every 100x from 2019-2024, ...",
      isComing: false,
    },
    {
      topImage: whyBanner,
      avatar: whyAvatar,
      name: "BUSD",
      symbol: "BUSD",
      desc: "description",
      isComing: false,
    },
  ],
};

const HomePage = () => {
  const isMobile = useIsMobileView();
  const chainId = useChainId();
  const cardsInfo = TOKENS_CARD_INFO[chainId];
  const [isOpenHowItWorksModal, setIsOpenHowItWorksModal] = useState(false);

  return (
    <>
      <Center pt={{ md: 10, base: 5 }} px={{ md: 6, base: "11px" }}>
        <Flex flexDirection={"column"} maxW="1358px">
          <Image
            src={isMobile ? topBannerMobile : topBannerPc}
            w={{ lg: "860px", md: "660px", base: "78%" }}
          />
          <Flex
            mt={{ lg: "20px", md: "18px", base: "13px" }}
            alignItems={{ md: "center", base: "flex-start" }}
            flexDirection={{ md: "row", base: "column" }}
            gap="13px"
          >
            <Center
              py={{ md: 2, base: "6px" }}
              px={{ md: 4, base: 2 }}
              color="white"
              fontWeight={"semibold"}
              border={"1px solid #FFF;"}
              borderRadius={"full"}
              order={{ md: 1, base: 2 }}
              fontSize={{ md: "md", base: "xs" }}
            >
              Turn your meme coins into big wins
            </Center>
            <Flex
              alignItems={"center"}
              gap={{ md: "26px", base: "6.8px" }}
              order={{ md: 2, base: 1 }}
            >
              <Icon
                width={{ md: "131px", base: "100px" }}
                height={{ md: "33px", base: "25px" }}
                viewBox="0 0 131 33"
                fill="none"
                ml="11px"
              >
                <path
                  d="M0.919922 26.5293H21.2334C22.0826 26.5293 22.8919 26.1694 23.4608 25.539L39.6535 7.5931C41.4941 5.55318 44.8808 6.85525 44.8808 9.60283V22.7765C44.8808 25.7596 48.7619 26.9144 50.3928 24.4166L59.6479 10.2418C61.2787 7.74397 65.1598 8.89882 65.1598 11.8819V22.1848C65.1598 25.2156 69.1416 26.3347 70.7206 23.7478L78.5556 10.9106C80.1345 8.32369 84.1163 9.44282 84.1163 12.4736V23.5293C84.1163 25.1861 85.4594 26.5293 87.1163 26.5293H95.0386C99.29 26.5293 103.419 25.1034 106.764 22.4798L122.332 10.2704"
                  stroke="#FCD535"
                  strokeWidth="4"
                />
                <path
                  d="M108.215 8.38965H123.273V23.4477"
                  stroke="#FCD535"
                  strokeWidth="4"
                />
              </Icon>
              <Center
                bg="brand"
                fontSize={{ md: "xl", base: "md" }}
                fontWeight={"bold"}
                borderRadius={"full"}
                px={{ md: 5, base: 3 }}
                py={{ md: 2, base: 1 }}
                cursor="pointer"
                _hover={{
                  textDecoration: "underline",
                }}
                onClick={() => setIsOpenHowItWorksModal(true)}
              >
                How it works?
              </Center>
            </Flex>
          </Flex>
          <Flex
            flexDirection={{ md: "row", base: "column" }}
            gap={{ md: 6, base: 4 }}
            mt={{ md: "40px", base: "20px" }}
            flexWrap={"wrap"}
            mb={"52px"}
            pos="relative"
          >
            {/* <TokenCard
              topImage={whyBanner}
              avatar={whyAvatar}
              name={"TF Boy"}
              symbol={"TFB"}
              desc={
                "FR It is a Bipolar Elephant，has two souls, MAD after goofing up every 100x from 2019-2024, ..."
              }
              isComing={false}
            />
            <TokenCard
              topImage={whyBanner}
              avatar={whyAvatar}
              name={"BUSD"}
              symbol={"BUSD"}
              desc={"description"}
              isComing={false}
            /> */}
            <>
              {cardsInfo.map((res: any) => (
                <TokenCard {...res} />
              ))}
            </>
            <TokenCard
              topImage={bnxBanner}
              avatar={bnxAvatar}
              name={"BinaryX"}
              symbol={"BNX"}
              desc={
                <>
                  BinaryX is the decentralized project behind{" "}
                  <Text
                    as="span"
                    textDecoration={"underline"}
                    cursor="pointer"
                    onClick={() =>
                      window.open(
                        "https://academy.binance.com/en/articles/what-is-play-to-earn-and-how-to-cash-out",
                        "_blank"
                      )
                    }
                  >
                    Play-to-Earn (P2E)
                  </Text>{" "}
                  web 3.0-based games like CyberDragon, CyberChess, Ai Hero, on
                  the{" "}
                  <Text
                    as="span"
                    textDecoration={"underline"}
                    cursor="pointer"
                    onClick={() =>
                      window.open(
                        "https://www.binance.com/en/blog/ecosystem/introducing-bnb-chain-the-evolution-of-binance-smart-chain-421499824684903436",
                        "_blank"
                      )
                    }
                  >
                    BNB chain
                  </Text>
                  .
                  <br />
                  BinaryX started as a decentralized derivative trading protocol
                  and altered the project's direction to accommodate the{" "}
                  <Text
                    as="span"
                    textDecoration={"underline"}
                    cursor="pointer"
                    onClick={() =>
                      window.open(
                        "https://academy.binance.com/en/articles/what-is-gamefi-and-how-does-it-work",
                        "_blank"
                      )
                    }
                  >
                    GameFi
                  </Text>{" "}
                  boom. The project was launched in 2019 by a group of
                  entrepreneurs, tech professionals, and marketing experts,
                  according to information published by BinaryX. The platform
                  offers various services such as infrastructural support, a DAO
                  governance framework, and community development to enhance
                  promising GameFi projects, aiming to drive innovation within
                  the blockchain gaming industry.
                </>
              }
              isComing={true}
            />
            <Flex
              flexDir={"column"}
              justifyContent={"flex-start"}
              pt="51px"
              pb={"20px"}
              alignItems={"center"}
              bg="#0E0E0E"
              border="1px solid rgba(252, 213, 53, 0.20)"
              _hover={{
                border: "2px solid #FCD535;",
              }}
              onClick={() =>
                window.open("https://forms.gle/MtXBCqQDhuAepLxE9", "_blank")
              }
              overflow={"hidden"}
              borderRadius={"4px"}
              cursor="pointer"
              color="white"
              w={{
                lg: "calc(100% / 3 - 16px)",
                md: "calc(50% - 12px)",
                base: "100%",
              }}
            >
              <Image src={extraCardLogo} w={"293px"} />
              <Text>What is your favorite MEME coin?</Text>
              <Flex alignItems={"center"} gap={"6px"}>
                <Text>Please tell us</Text>
                <Image src={goIcon} h="24px" mt="-2px" />
              </Flex>
            </Flex>
            {!isMobile && (
              <Box
                boxSize={{ lg: "12rem", md: "12rem" }}
                pos="absolute"
                top={{ lg: "-11rem", md: "4.5rem" }}
                right={{ lg: "0", md: "0" }}
                className="spin-logo"
                zIndex={2}
                display={{ lg: "block", md: "none", base: "none" }}
              >
                <Image
                  boxSize={{ lg: "12rem", md: "12rem" }}
                  src={homepageSpinIcon}
                />
              </Box>
            )}
          </Flex>
        </Flex>
      </Center>
      <CustomModal
        title={"How it Works?"}
        isOpen={isOpenHowItWorksModal}
        onClose={() => setIsOpenHowItWorksModal(false)}
      >
        <Text color="white" fontSize={"xs"} lineHeight={"normal"}>
          FomoMe is an innovative project built on the BNB Chain, designed to
          empower BEP20 tokens by introducing engaging and gamified elements to
          their communities. By integrating gameplay mechanics with token
          economics, FomoMe transforms the standard interactions within the
          BEP20 ecosystem, making it more interactive and rewarding for users.
          <br />
          In each game round, players can purchase one or more Keys, which
          resets the countdown timer and positions them as the current leader.
          Each purchase of a Key slightly increases its price, creating a
          dynamic market.
          <br />
          As the game progresses, later players who continue to buy Keys can
          generate passive income for earlier participants.
          <br />
          When the countdown reaches zero, the last player to purchase a Key is
          declared the ultimate winner.
          <br />
          <Text fontWeight={"bold"}>Purpose And Goals Of The Project</Text>
          The primary purpose of FomoMe is to enhance the utility and engagement
          of BEP20 tokens through gamification. The project aims to:
          <br />
          <br />
          1. Empower Communities: By incorporating gameplay elements, FomoMe
          fosters a more active and engaged community around BEP20 tokens,
          encouraging participation and interaction among users.
          <br />
          <br />
          2. Create Passive Income Opportunities: The game's mechanics are
          designed to ensure that early participants can benefit financially
          from the ongoing activities of later players, promoting a sustainable
          income model. <br />
          <br />
          3. Introduce Diverse Game Modes: FomoMe features two distinct game
          modes—Long-Term and Fast Mode—each with unique rules and round
          durations. This variety caters to different player preferences and
          enhances the overall gaming experience. <br />
          <br />
          4. Incentivize Participation through Airdrops: Each Key purchase gives
          players a chance to receive token airdrops from a growing prize pool,
          further motivating engagement and investment in the game. <br />
          <br />
          Through these goals, FomoMe aims to redefine the interaction between
          players and BEP20 tokens, creating a vibrant ecosystem that rewards
          participation and fosters community growth.{" "}
          <Text
            color="#0077FA"
            cursor="pointer"
            onClick={() =>
              window.open("https://fomome.gitbook.io/fomome", "_blank")
            }
            as="span"
          >
            More&gt;
          </Text>
        </Text>
      </CustomModal>
    </>
  );
};

const TokenCard = ({
  topImage,
  avatar,
  name,
  symbol,
  desc,
  isComing,
}: {
  topImage: string;
  avatar: string;
  name: string;
  symbol: string;
  desc: string | JSX.Element;
  prizePool?: string;
  isComing: boolean;
}) => {
  const navigate = useNavigate();
  const pageUrl = `/game?token=${symbol}`;
  const { twitter, tg, website } =
    socialMediaLinks[symbol.toLowerCase()] || socialMediaLinks["why"];
  const chainId = useChainId();
  const fomoContract = getContract(chainId, "fomome")?.[symbol.toLowerCase()];
  const tokenDecimal = getMemeTokenInfo(chainId, symbol)?.decimal || 18;

  const fomomeContractInfo = {
    address: fomoContract,
    abi: fomomeContractAbi,
    chainId: chainId,
  };
  const tokenPrices = useTokenPrices(chainId, [symbol.toLowerCase()]);
  const tokenPrice = () => tokenPrices[symbol.toLowerCase()] || 0;

  const { data } = useReadContract({
    ...fomomeContractInfo,
    functionName: "getCurrentRoundInfo",
  });

  const playbookContractInfo = {
    address: getContract(chainId, "playBook"),
    abi: playbookContractAbi,
    chainId: chainId,
  };
  const { data: totalUser } = useReadContract({
    ...playbookContractInfo,
    functionName: "pID_",
  });

  const curPot = data?.[5];
  const roundNum = Number(data?.[1] || 1);

  const prizePool = curPot
    ? formatAmount(curPot as BigNumber, tokenDecimal, 4, 0, true, true)
    : 0;
  const usdValue = numberWithCommas(
    +(
      ((curPot
        ? formatAmount(curPot as BigNumber, tokenDecimal, 6, 0, false, true)
        : 0) as number) * tokenPrice()
    ).toFixed(2)
  );

  const gotoGamePage = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (isComing) return;
    navigate(pageUrl);
  };

  return (
    <Flex
      direction={"column"}
      borderRadius={"4px"}
      border="1px solid rgba(252, 213, 53, 0.20)"
      bg="b02"
      cursor={isComing ? "not-allowed" : "pointer"}
      _hover={
        isComing
          ? {}
          : {
              border: "2px solid #FCD535;",
            }
      }
      onClick={gotoGamePage}
      overflow={"hidden"}
      pos="relative"
      minH="433px"
      w={{
        lg: "calc(100% / 3 - 16px)",
        md: "calc(50% - 12px)",
        base: "100%",
      }}
    >
      <Box pos="relative" h="180px">
        <Image src={topImage} h="100%" w="100%" objectFit={"fill"} />

        <Flex
          justifyContent={"flex-end"}
          pr="10px"
          w="100%"
          h="40px"
          bg="rgba(0, 0, 0, 0.70)"
          pos="absolute"
          bottom={0}
          left={0}
          alignItems={"center"}
          gap="3px"
        >
          {roundNum && !isComing && (
            <>
              <Icon width="18px" height="18px" viewBox="0 0 18 18" fill="none">
                <path
                  d="M9 0L9.95424 6.37826L14.7851 2.1056L11.4162 7.605L17.8633 7.43717L11.7476 9.48448L16.7942 13.5L10.7934 11.1373L12.0782 17.4572L9 11.79L5.92182 17.4572L7.20662 11.1373L1.20577 13.5L6.25239 9.48448L0.13673 7.43717L6.58379 7.605L3.21491 2.1056L8.04576 6.37826L9 0Z"
                  fill="#FCD535"
                />
              </Icon>
              <Text fontSize={"sm"} fontFamily={"Rubik One"} color="white">
                ROUND {roundNum}
              </Text>
              <Icon width="18px" height="18px" viewBox="0 0 18 18" fill="none">
                <path
                  d="M9 0L9.95424 6.37826L14.7851 2.1056L11.4162 7.605L17.8633 7.43717L11.7476 9.48448L16.7942 13.5L10.7934 11.1373L12.0782 17.4572L9 11.79L5.92182 17.4572L7.20662 11.1373L1.20577 13.5L6.25239 9.48448L0.13673 7.43717L6.58379 7.605L3.21491 2.1056L8.04576 6.37826L9 0Z"
                  fill="#FCD535"
                />
              </Icon>
            </>
          )}
        </Flex>

        <Image
          src={avatar}
          boxSize={"80px"}
          pos="absolute"
          left="18px"
          top="110px"
        />
      </Box>
      <Flex direction={"column"} px={5} py={5} mt={"10px"} gap={3}>
        <Text color="white" fontSize={"lg"} fontWeight={"bold"}>
          {name}(${symbol})
        </Text>
        <Text
          color="b07"
          fontSize={"xs"}
          h={isComing ? "110px" : "36px"}
          textOverflow={"ellipsis"}
          overflow={"hidden"}
          className={isComing ? "clamp-line6" : "clamp-line2"}
        >
          {desc}
        </Text>

        {!isComing && (
          <Flex justifyContent={"space-between"}>
            <Flex gap={1}>
              <Icon width="16px" height="16px" viewBox="0 0 16 16" fill="none">
                <path
                  d="M2.40297 10.3536V11.2939C2.40633 13.0091 4.91177 14.3996 7.99961 14.3996C10.9978 14.3996 13.4439 13.0905 13.5929 11.4486L13.5996 11.2927V10.3525C12.5546 11.5871 10.4636 12.4133 8.00073 12.4133C5.53897 12.4133 3.44905 11.5871 2.40297 10.3525V10.3536ZM13.5996 7.59466C13.3319 7.90885 12.9948 8.19743 12.6017 8.45343L12.5569 8.47903C12.4113 8.57212 12.2545 8.66172 12.0954 8.74434C12.0148 8.78623 11.9297 8.82346 11.8468 8.86419C11.6417 8.96064 11.4324 9.04723 11.2196 9.12368C11.055 9.18419 10.8836 9.23772 10.7089 9.28776L10.5263 9.34128C10.2243 9.42039 9.91846 9.48331 9.61017 9.52979C9.42761 9.55656 9.24281 9.58099 9.05353 9.59961L8.81161 9.62288C8.54617 9.64266 8.27513 9.65779 7.99961 9.65779C7.6476 9.65621 7.29588 9.6368 6.94569 9.59961C6.75529 9.58099 6.57161 9.55888 6.38905 9.52979C6.30729 9.51583 6.22553 9.50535 6.14601 9.49023C5.91529 9.44834 5.68681 9.3983 5.46953 9.34128C5.40905 9.32615 5.35305 9.30637 5.29369 9.29008C5.03081 9.21492 4.77176 9.12598 4.51753 9.02361C4.39523 8.97424 4.27422 8.92147 4.15465 8.86536C4.07065 8.82579 3.98665 8.78739 3.90601 8.74666L3.66857 8.61634L3.44457 8.48136L3.40089 8.45459C3.08617 8.25212 2.80729 8.02754 2.57209 7.78317L2.40409 7.59699V8.53605C2.40409 8.91074 2.53065 9.26681 2.75129 9.59961C2.80623 9.68258 2.86569 9.76222 2.92937 9.83815C2.93609 9.8463 2.94281 9.85561 2.95177 9.86376C3.16199 10.1049 3.40187 10.3161 3.66521 10.4921L3.88361 10.6318L3.95977 10.6783C4.03593 10.7214 4.11433 10.7621 4.19273 10.804L4.32041 10.868C4.44903 10.931 4.57978 10.9892 4.71241 11.0425C4.78745 11.0716 4.86025 11.1019 4.93753 11.1298C5.01145 11.1577 5.08985 11.181 5.16713 11.2078C5.36961 11.2756 5.57475 11.3347 5.78201 11.3846C5.84137 11.3986 5.90409 11.4114 5.96681 11.4242L6.11241 11.4568L6.25913 11.4847L6.45513 11.5173L6.60857 11.5406L6.76425 11.5627L6.95801 11.5859L7.13161 11.6011L7.30633 11.6139L7.47433 11.6255C7.82647 11.6465 8.17947 11.6465 8.53161 11.6255C8.58761 11.6232 8.64361 11.6174 8.69961 11.6139C8.81721 11.6057 8.93369 11.5976 9.04681 11.5848C9.21555 11.5687 9.38366 11.5462 9.55081 11.5173C9.61577 11.508 9.68185 11.4975 9.74569 11.4847L9.89353 11.4556L10.0391 11.4242L10.2239 11.3846C10.4312 11.333 10.6366 11.274 10.8399 11.2078C10.9161 11.181 10.9922 11.1577 11.0684 11.1298C11.1446 11.1019 11.2185 11.0716 11.2924 11.0414C11.4254 10.9891 11.5562 10.9308 11.6844 10.8668L11.7494 10.8366L11.9308 10.7411L12.045 10.6783L12.1223 10.6318C12.4791 10.4233 12.801 10.1561 13.0754 9.84048C13.1319 9.77271 13.1849 9.70202 13.2345 9.6287L13.2524 9.59961C13.4319 9.34018 13.5473 9.03888 13.5884 8.72223L13.5996 8.53488V7.59234V7.59466ZM8.00073 1.59961C4.90953 1.59961 2.40297 2.99132 2.40297 4.70885H2.39961V5.77939C2.39961 6.15175 2.52617 6.50899 2.74569 6.84295C2.75241 6.8511 2.75801 6.86157 2.76473 6.87205C2.81289 6.94186 2.86553 7.01168 2.92377 7.0815L2.94617 7.10594C3.21587 7.41138 3.53036 7.67058 3.87801 7.87394L3.95641 7.92048C4.03033 7.96354 4.10873 8.00426 4.18825 8.04615L4.31481 8.11016C4.39038 8.14717 4.46656 8.18286 4.54329 8.21721L4.70681 8.2847C4.78185 8.31495 4.85577 8.34637 4.93305 8.3743L5.16041 8.44994C5.23097 8.47321 5.29817 8.49648 5.36985 8.51743L5.37881 8.51859C5.39897 8.52441 5.42361 8.52906 5.44377 8.53605C5.55446 8.56814 5.66573 8.59801 5.77753 8.62565C5.80329 8.6303 5.82681 8.63728 5.85145 8.6431L5.90745 8.65474L5.96345 8.66637C6.06034 8.68933 6.15781 8.70951 6.25577 8.72688L6.35657 8.74666C6.39017 8.75132 6.42377 8.75481 6.45513 8.76063L6.76089 8.80368L6.88409 8.81997L6.96137 8.82695C7.07337 8.83859 7.18761 8.8479 7.30297 8.85721C7.34777 8.8607 7.38921 8.86536 7.43401 8.86652C7.44857 8.86885 7.46089 8.86885 7.47545 8.86885C7.82581 8.88635 8.17677 8.88635 8.52713 8.86885C8.54169 8.86652 8.55401 8.86652 8.56857 8.86652C8.61337 8.86536 8.65481 8.8607 8.69961 8.85721C8.81362 8.84898 8.9275 8.83889 9.04121 8.82695L9.11849 8.81997L9.24169 8.80368C9.34384 8.79113 9.44577 8.77678 9.54745 8.76063L9.64489 8.74666C9.77668 8.72236 9.90811 8.69598 10.0391 8.66754C10.0582 8.66172 10.0783 8.65823 10.0974 8.6559L10.15 8.64426C10.1758 8.63961 10.1993 8.63263 10.2239 8.62681C10.337 8.60005 10.4479 8.56863 10.5566 8.53721C10.579 8.53255 10.6014 8.5279 10.6226 8.52092L10.6305 8.51859C10.7022 8.49765 10.7705 8.47437 10.8399 8.4511C10.9183 8.42783 10.9945 8.40339 11.0684 8.37546C11.1438 8.34662 11.2189 8.31675 11.2935 8.28586L11.457 8.21837C11.6571 8.12846 11.8533 8.02946 12.045 7.92165L12.1223 7.8751C12.4791 7.66665 12.801 7.39942 13.0754 7.08383C13.1318 7.01681 13.1849 6.9469 13.2345 6.87437L13.2524 6.84295C13.473 6.51248 13.5996 6.15408 13.5996 5.78055V4.71001C13.5996 2.99015 11.0942 1.59961 8.00073 1.59961Z"
                  fill="#666666"
                />
              </Icon>
              <Text color="b07" fontSize={"xs"}>
                Total Prize Pool
              </Text>
            </Flex>
            <Flex direction={"column"} alignItems={"flex-end"} gap="2px">
              <Text fontSize={"xs"} fontWeight={"medium"} color="white">
                {prizePool} {symbol}
              </Text>
              {/* TODO: USD */}
              {/* <Text fontSize={"10px"} fontWeight={"medium"} color="b06">
                ≈{usdValue} USD
              </Text> */}
            </Flex>
          </Flex>
        )}

        {!isComing && (
          <Flex justifyContent={"space-between"}>
            <Flex gap={1}>
              <Icon width="16px" height="16px" viewBox="0 0 16 16" fill="none">
                <path
                  d="M5.60319 1.60127C5.79443 1.60136 5.98497 1.62435 6.17074 1.66975C6.35348 1.71311 6.53138 1.77478 6.70175 1.85382C6.85803 1.92545 7.00617 2.01365 7.14361 2.11692C7.25618 2.20148 7.35704 2.30058 7.44357 2.41164C7.61284 2.63409 7.74056 2.88526 7.8206 3.15308C7.85119 3.25769 7.87864 3.36318 7.9029 3.46943C7.59948 3.59193 7.52473 3.65593 7.31877 3.803C7.147 3.96114 7.03749 4.06194 6.89714 4.28178C6.79148 4.41394 6.64549 4.74194 6.58501 4.97618C6.55781 5.07954 6.46143 5.47391 6.44306 5.70182C6.43001 5.81394 6.38943 6.09388 6.40255 6.50118C6.34553 6.5767 6.30681 6.64345 6.27282 6.7221C6.24428 6.80607 6.23314 6.87423 6.22009 6.97471C6.2094 7.09791 6.22553 7.14841 6.2647 7.299C6.31551 7.45375 6.30828 7.43628 6.38226 7.57266C6.4894 7.73196 6.57701 7.76242 6.64985 7.79359C6.68159 7.9079 6.74713 8.13004 6.74713 8.13004C6.74713 8.13004 6.80793 8.2805 6.85657 8.39833C6.92741 8.54988 6.99442 8.60345 6.99442 8.60345C6.99442 8.60345 7.15698 8.75058 7.30245 8.89286C7.34457 8.94348 7.45542 9.06783 7.46054 9.27679C7.47673 9.44159 7.47269 9.41369 7.47269 9.58207C7.47333 9.71391 7.46015 9.73017 7.41996 9.84518C7.37996 9.93004 7.35135 9.99993 7.26188 10.0977C7.18732 10.1819 7.09388 10.2681 6.94566 10.3608C6.81535 10.4479 6.62732 10.5559 6.3335 10.6345C6.10437 10.6934 5.93599 10.754 5.66463 10.8501C5.34898 10.9858 5.32441 11.0145 5.14508 11.139C4.81733 11.3999 4.80709 11.7935 4.80927 11.7687C4.81145 11.7439 4.77452 12.0063 4.76402 12.1067C4.56338 12.0939 4.35922 12.0781 4.1477 12.0588C3.87843 12.0343 3.6095 12.0062 3.34098 11.9745C3.09712 11.9461 2.85385 11.9129 2.61132 11.8747C2.39244 11.8399 2.20997 11.8046 2.05593 11.7693C1.95501 11.7544 1.85833 11.7185 1.77215 11.6639C1.67095 11.5112 1.61734 11.3319 1.6181 11.1487C1.58295 10.7766 1.59796 10.4015 1.66271 10.0335C1.67958 9.8051 1.78416 9.59213 1.95455 9.43916C2.12236 9.29953 2.31297 9.18983 2.51801 9.11487C2.73738 9.03234 2.96059 8.96038 3.18687 8.89926C3.40447 8.84185 3.61119 8.7495 3.79903 8.62559C3.91643 8.5534 4.02291 8.4648 4.11525 8.36249C4.18219 8.28811 4.23568 8.20265 4.27333 8.10994C4.30898 8.02681 4.3269 7.93721 4.32607 7.84684C4.32563 7.74497 4.32157 7.64314 4.31391 7.54156C4.30949 7.39865 4.25332 7.26221 4.15583 7.15762C4.05693 7.05721 3.95418 6.96067 3.8478 6.86822C3.78913 6.80931 3.74233 6.73967 3.70994 6.6631C3.67346 6.57554 3.63698 6.48614 3.6005 6.39481C3.56622 6.28321 3.53378 6.17104 3.50322 6.05836C3.45326 6.04216 3.4066 6.01717 3.36543 5.98457C3.31649 5.94086 3.27294 5.89146 3.2357 5.83743C3.18125 5.75355 3.1415 5.66101 3.11813 5.56377C3.07917 5.46038 3.06392 5.34955 3.07353 5.23948C3.08038 5.15339 3.0981 5.06851 3.12626 4.98687C3.15552 4.90586 3.1995 4.83096 3.25599 4.76594C3.24922 4.49885 3.26276 4.23163 3.2965 3.96658C3.32551 3.72148 3.37296 3.47892 3.43845 3.24095C3.50253 2.99352 3.60807 2.75873 3.75058 2.54655C3.86383 2.36485 4.00629 2.20308 4.17221 2.06777C4.31681 1.95074 4.47631 1.85342 4.64652 1.77836C4.80189 1.71033 4.9654 1.66264 5.13298 1.63647C5.28858 1.6123 5.44579 1.59998 5.60326 1.59961V1.60127H5.60319Z"
                  fill="#666666"
                />
                <path
                  d="M9.85287 3.57699C10.0441 3.57708 10.2346 3.60007 10.4204 3.64547C10.6032 3.68882 10.7811 3.75049 10.9514 3.82953C11.1077 3.90116 11.2558 3.98937 11.3933 4.09264C11.5059 4.17719 11.6067 4.27629 11.6933 4.38736C11.8625 4.6098 11.9902 4.86098 12.0703 5.1288C12.1444 5.38209 12.2 5.64046 12.2365 5.90185C12.2724 6.18416 12.29 6.46851 12.2892 6.75312C12.3353 6.79002 12.3727 6.83666 12.3987 6.88969C12.4267 6.95011 12.447 7.01366 12.4595 7.079C12.4769 7.17264 12.4797 7.26838 12.4676 7.36278C12.4579 7.48393 12.4291 7.6028 12.3825 7.71504C12.346 7.79132 12.2967 7.86071 12.2365 7.92016C12.1842 7.97264 12.1204 8.01219 12.0501 8.03568C12.0195 8.14836 11.9871 8.26052 11.9528 8.37212C11.9162 8.46332 11.8798 8.55254 11.8392 8.64041C11.8028 8.71672 11.7534 8.78612 11.6933 8.84553C11.5888 8.93293 11.4861 9.0224 11.3852 9.11388C11.2942 9.21841 11.2389 9.34918 11.2271 9.48726C11.2082 9.59302 11.2014 9.7006 11.2069 9.8079C11.2163 9.92013 11.2451 10.0299 11.292 10.1323C11.3473 10.2491 11.4243 10.3543 11.519 10.4423C11.6468 10.5552 11.7937 10.6443 11.9528 10.7054C12.1283 10.7798 12.3084 10.843 12.4919 10.8947C12.6843 10.9499 12.8737 11.0148 13.0595 11.0894C13.2349 11.1573 13.4 11.2494 13.55 11.363C13.6952 11.4765 13.8014 11.6323 13.854 11.8089C13.8907 11.945 13.9151 12.084 13.927 12.2244C13.9432 12.3892 13.9513 12.5559 13.9513 12.7242C13.9521 12.8827 13.9399 13.0411 13.9148 13.1977C13.9025 13.3152 13.8681 13.4293 13.8135 13.5341C13.7345 13.6087 13.6362 13.6597 13.5297 13.6813C13.3419 13.7388 13.1511 13.7861 12.9582 13.8232C12.7271 13.8686 12.4758 13.9091 12.192 13.9448C11.9116 13.9801 11.6305 14.01 11.3489 14.0344C11.0762 14.0581 10.8032 14.0774 10.53 14.0924C10.2705 14.1065 10.0435 14.1134 9.853 14.1134C9.66247 14.1134 9.43949 14.1065 9.18413 14.0924C8.92871 14.0782 8.66925 14.0591 8.3977 14.0344C8.12843 14.0099 7.8595 13.9818 7.59098 13.95C7.34712 13.9217 7.10385 13.8884 6.86132 13.8503C6.64244 13.8155 6.45997 13.7802 6.30593 13.7449C6.20501 13.73 6.10833 13.6941 6.02215 13.6395C5.92095 13.4868 5.86734 13.3075 5.8681 13.1243C5.83295 12.7522 5.84796 12.3771 5.91271 12.0091C5.92958 11.7807 6.03416 11.5677 6.20455 11.4147C6.37236 11.2751 6.56297 11.1654 6.76801 11.0905C6.98738 11.0079 7.21059 10.936 7.43687 10.8748C7.65447 10.8174 7.86119 10.7251 8.04903 10.6012C8.16643 10.529 8.27291 10.4404 8.36525 10.3381C8.43219 10.2637 8.48568 10.1782 8.52333 10.0855C8.55898 10.0024 8.5769 9.9128 8.57607 9.82243C8.57563 9.72056 8.57157 9.61873 8.56391 9.51715C8.55949 9.37424 8.50332 9.2378 8.40583 9.13321C8.30693 9.0328 8.20417 8.93626 8.0978 8.8438C8.03913 8.78489 7.99233 8.71526 7.95994 8.63868C7.92346 8.55113 7.88698 8.46172 7.8505 8.3704C7.81622 8.25879 7.78378 8.14663 7.75322 8.03395C7.70326 8.01775 7.6566 7.99276 7.61543 7.96016C7.56649 7.91644 7.52294 7.86705 7.4857 7.81302C7.43125 7.72914 7.3915 7.63659 7.36813 7.53936C7.32917 7.43596 7.31392 7.32514 7.32353 7.21507C7.33038 7.12898 7.3481 7.0441 7.37626 6.96246C7.40552 6.88145 7.4495 6.80655 7.50599 6.74153C7.49922 6.47444 7.51276 6.20721 7.5465 5.94217C7.57551 5.69707 7.62296 5.4545 7.68845 5.21654C7.75253 4.96911 7.85807 4.73432 8.00058 4.52214C8.11383 4.34044 8.25629 4.17867 8.42221 4.04336C8.56681 3.92632 8.72631 3.829 8.89652 3.75395C9.05189 3.68592 9.2154 3.63823 9.38298 3.61206C9.53858 3.58789 9.69579 3.57556 9.85325 3.5752V3.57699H9.85287Z"
                  fill="#666666"
                />
              </Icon>
              <Text color="b07" fontSize={"xs"}>
                User
              </Text>
            </Flex>
            <Flex direction={"column"} alignItems={"flex-end"} gap="2px">
              <Text fontSize={"xs"} fontWeight={"medium"} color="white">
                {totalUser ? Number(totalUser) + 1 : 0}
              </Text>
            </Flex>
          </Flex>
        )}
      </Flex>
      <Flex w="100%" h="48px" pos="absolute" bottom="0">
        <Flex
          alignItems={"center"}
          justifyContent={"center"}
          gap={3}
          px={"14px"}
          py={4}
          borderTop={"1px solid rgba(252, 213, 53, 0.20);"}
          boxSizing="border-box"
        >
          <Icon
            width="15px"
            height="15px"
            viewBox="0 0 15 15"
            fill="none"
            color="b09"
            _hover={{ color: "brand" }}
            cursor="pointer"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              twitter && window.open(twitter, "_blank");
            }}
          >
            <path
              d="M11.8134 0.0751953H14.1135L9.0884 6.00545L15 14.0752H10.3713L6.74593 9.1809L2.59768 14.0752H0.2962L5.67097 7.73213L0 0.0751953H4.74622L8.0232 4.54873L11.8134 0.0751953ZM11.0061 12.6536H12.2806L4.05367 1.42208H2.68597L11.0061 12.6536Z"
              fill="currentColor"
            />
          </Icon>
          <Icon
            width="20px"
            height="21px"
            viewBox="0 0 20 21"
            fill="none"
            color="b09"
            _hover={{ color: "brand" }}
            cursor="pointer"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              website && window.open(website, "_blank");
            }}
          >
            <path
              d="M5.92095 8.19283H3.44C3.26513 8.80498 3.17675 9.43856 3.17741 10.0752C3.17741 10.7283 3.26871 11.3599 3.44094 11.9575H5.92189C5.81836 11.3552 5.76565 10.7274 5.76565 10.0752C5.76565 9.42295 5.81742 8.79519 5.92095 8.19283ZM6.87813 8.19283C6.7612 8.81341 6.70353 9.44369 6.70589 10.0752C6.70589 10.7321 6.76236 11.3599 6.87813 11.9575H9.52943V8.19283H6.87813ZM8.25695 16.6737C7.25312 15.6063 6.52379 14.3107 6.13177 12.8987H3.78635C4.20589 13.8194 4.8245 14.6357 5.59757 15.2884C6.37065 15.9413 7.27893 16.4143 8.25695 16.6737ZM9.52943 16.6079V12.8987H7.11342C7.55577 14.3161 8.36048 15.5491 9.52943 16.6079ZM8.25695 3.47755C7.27903 3.73683 6.3708 4.20982 5.59773 4.86245C4.82466 5.51508 4.206 6.33109 3.78635 7.25167H6.13177C6.52352 5.83978 7.25252 4.54426 8.25601 3.47661L8.25695 3.47755ZM9.52943 3.54342C8.36048 4.59943 7.55671 5.83331 7.11342 7.25167H9.52943V3.54154V3.54342ZM14.0791 8.19283C14.1826 8.79519 14.2353 9.42295 14.2353 10.0752C14.2353 10.7274 14.1826 11.3552 14.0791 11.9575H16.561C16.7323 11.3599 16.8235 10.7283 16.8235 10.0752C16.8235 9.42201 16.7323 8.79049 16.56 8.19283H14.0791ZM13.1219 8.19283H10.4706V11.9575H13.1219C13.2367 11.3599 13.2942 10.7321 13.2942 10.0752C13.2942 9.41825 13.2376 8.79049 13.1219 8.19283ZM11.7431 16.6737C12.7211 16.4143 13.6294 15.9413 14.4024 15.2884C15.1756 14.6357 15.7942 13.8194 16.2137 12.8987H13.8683C13.4765 14.3107 12.7466 15.6062 11.7431 16.6737ZM10.4706 16.6079C11.6395 15.55 12.4433 14.3161 12.8866 12.8987H10.4706V16.6079ZM11.7431 3.47755C12.7467 4.54483 13.4761 5.84003 13.8683 7.25167H16.2146C15.7951 6.33091 15.1765 5.51473 14.4034 4.86192C13.6303 4.20912 12.722 3.73599 11.744 3.47661L11.7431 3.47755ZM10.4706 3.54342V7.25167H12.8866C12.4442 5.83425 11.6395 4.60037 10.4706 3.54154V3.54342ZM10 18.0752C7.87828 18.0752 5.84345 17.2323 4.34315 15.732C2.84286 14.2318 2 12.1969 2 10.0752C2 7.95346 2.84286 5.91863 4.34315 4.41833C5.84345 2.91805 7.87828 2.0752 10 2.0752C12.1218 2.0752 14.1566 2.91805 15.6568 4.41833C17.1572 5.91863 18 7.95346 18 10.0752C18 12.1969 17.1572 14.2318 15.6568 15.732C14.1566 17.2323 12.1218 18.0752 10 18.0752Z"
              fill="currentColor"
            />
          </Icon>
          <Icon
            width="20px"
            height="21px"
            viewBox="0 0 20 21"
            fill="none"
            color="b09"
            _hover={{ color: "brand" }}
            cursor="pointer"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              tg && window.open(tg, "_blank");
            }}
          >
            <path
              d="M8.64311 15.2891L8.87639 11.6526L15.268 5.70471C15.5508 5.43865 15.2092 5.30952 14.835 5.54178L6.94556 10.6898L3.53284 9.57263C2.80027 9.3577 2.79272 8.83337 3.69982 8.45464L16.9907 3.16019C17.5983 2.87679 18.1807 3.31533 17.9474 4.27819L15.6834 15.2891C15.5257 16.0709 15.0683 16.2598 14.4356 15.8993L10.9901 13.269L9.33372 14.9277C9.1424 15.1253 8.98464 15.2891 8.64311 15.2891Z"
              fill="currentColor"
            />
          </Icon>
        </Flex>
        {isComing ? (
          <Center
            fontSize={"lg"}
            color="b08"
            fontFamily={"Rubik One"}
            flex="1"
            h="48px"
            bg="b03"
          >
            Coming Soon..
          </Center>
        ) : (
          <Button
            variant={"brand"}
            fontFamily={"Rubik One"}
            fontSize={"lg"}
            flex="1"
            h="48px"
            border="none"
          >
            FOMO ${symbol}
          </Button>
        )}
      </Flex>
    </Flex>
  );
};

export default HomePage;
